import React from 'react'
import { GoalCanvasCard } from './GoalCanvasCard.jsx'
import { useGoals } from './hooks/useGoals.js'

export function GoalCanvasZone({
  ownerUserId,
  sessionId,
  goalSnapshot = null,
  onNavigateGoals,
  onNavigateGoal,
  readOnly = false,
}) {
  // When a snapshot is provided (completed session), skip the live API call.
  const isSnapshot = goalSnapshot !== null
  const { goals: liveGoals, loading, setStatusLabel } = useGoals({
    ownerUserId,
    enabled: !!ownerUserId && !isSnapshot,
  })

  const visibleGoals = isSnapshot
    ? goalSnapshot
    : liveGoals.filter((g) => g.status === 'active')

  if (!isSnapshot && loading) return null

  return (
    <div style={styles.zone}>
      {visibleGoals.length === 0 ? (
        <button style={styles.emptyPrompt} onClick={isSnapshot ? undefined : () => onNavigateGoals?.()}>
          {isSnapshot
            ? 'No active goals at the time of this session.'
            : 'No active goals. Set goals on the Goals page \u2192'}
        </button>
      ) : (
        <div style={styles.cards}>
          {visibleGoals.map((goal) => (
            <GoalCanvasCard
              key={goal.goalId}
              goal={goal}
              ownerUserId={ownerUserId}
              onSetStatusLabel={isSnapshot ? undefined : setStatusLabel}
              onNavigateGoal={isSnapshot ? undefined : onNavigateGoal}
              onNavigateGoals={isSnapshot ? undefined : onNavigateGoals}
              readOnly={readOnly || isSnapshot}
            />
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  zone: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '16px',
  },
  emptyPrompt: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    color: 'var(--text-secondary)',
    padding: 0,
    textAlign: 'left',
  },
}
